import { VehicleValuationStatus } from "@/api-schema-enums";
import { EmptyValue } from "@/components/ui/empty-value";
import { VEHICLE_VALUATION_STATUS_TRANSLATIONS } from "@/components/vehicle-valuation/vehicle-valuation-status-translations";
import { useTranslation } from "react-i18next";
import { Badge } from "../ui/badge";
import { getVehicleValuationStatusBadgeVariant } from "./_helpers/get-vehicle-valuation-status-badge-variant";

interface VehicleValuationStatusBadgeProps {
  status: VehicleValuationStatus | null;
}

export const VehicleValuationStatusBadge = ({ status }: VehicleValuationStatusBadgeProps) => {
  const { t } = useTranslation("fab");

  if (!status) {
    return <EmptyValue />;
  }

  return (
    <Badge className="w-min text-center" {...getVehicleValuationStatusBadgeVariant(status)}>
      {t(VEHICLE_VALUATION_STATUS_TRANSLATIONS[status])}
    </Badge>
  );
};
